/**
 * number of milliseconds delayed between "running" handleMovement function calls
 */
export const timePeriodBetweenCountdownChecks = 2